import React, { useState } from "react";
import { Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { FaBars } from "react-icons/fa";
import { Button, Typography } from "antd";
import logo from "../../assets/logo/GII.png";
import ForgotResetPassword from "../auth/ForgotResetPassword";
import { PAGE_TITLE } from "../constant/reportType";
import "./header.scss";
import { getLocalStorageData } from "../../utils/LocalStorageService";

const Header = () => {
  const navigate = useNavigate();
  const [resetPasswordShow, setResetPasswordShow] = useState(false);

  const handleLogOut = () => navigate("/logout");
  const handleResetClick = () => setResetPasswordShow(true);
  const { Text } = Typography;
  const localStorageObj: any = getLocalStorageData("localUser");

  return (
    <>
      <header className="dashboard-header shadow-sm bg-white">
        <Container
          fluid
          className="px-4 py-2 d-flex justify-content-between align-items-center"
        >
          {/* Left Section */}
          <div className="d-flex align-items-center gap-3">
              {/* Mobile Toggle */ }
              <Button
                type="text"
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasSidebar"
                aria-controls="offcanvasSidebar"
                className="d-lg-none text-accent p-0"
                icon={<FaBars />}
              />
         

          {/* Logo & Brand Text */}
          <div className="d-flex align-items-center">
            <div className="d-none d-lg-block">
              <img src={logo} alt="Akakshi Logo" style={{ height: 75, width: 75 }} />
            </div>
          </div>

        </div>
        {/* Right Section */}
        <div className="d-flex align-items-center gap-4">
          <div className="help-text d-none d-md-block fw-semibold text-dark text-nowrap">
            <span>Need Help? Contact us</span>
          </div>
          {localStorageObj != null ?
            <div className="dropdown user-info d-flex align-items-center">
              <div
                className="d-flex align-items-center"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <span className="user-name me-3 text-nowrap d-none d-sm-block"> {localStorageObj?.username}</span>
                <div className="avatar-circle"> {localStorageObj.username.charAt(0).toUpperCase()}</div>
              </div>

              <ul className="dropdown-menu dropdown-menu-end dropdown-menu-light">
                <li onClick={() => navigate("/about")}>
                  <span className="dropdown-item cursor-pointer">About Us</span>
                </li>
                <li onClick={handleResetClick}>
                  <span className="dropdown-item cursor-pointer">Reset Password</span>
                </li>
                <hr className="border-1 m-0 border-secondary" />
                <li onClick={handleLogOut}>
                  <span className="dropdown-item cursor-pointer">Sign Out</span>
                </li>
              </ul>
            </div>
            : null}
        </div>
      </Container>
    </header >

      { resetPasswordShow && (
        <ForgotResetPassword
          forgotResetShow={resetPasswordShow}
          setForgotResetShow={setResetPasswordShow}
          title={PAGE_TITLE.RESET_PASSWORD}
        />
      )
}
    </>
  );
};

export default Header;
